// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"52f37ee5","309":"e4bcf2d6","622":"febde97f"}[chunkId] + ".chunk.js";
};